import { IApplicationState } from '../../types/redux';

export function getHasProgressOfConstruction(state: IApplicationState) {
  const {
    newbuilding: { hasProgressOfConstruction },
  } = state;

  return hasProgressOfConstruction;
}
